import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Transition as _Transition, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4" }
const _hoisted_2 = { class: "flex items-center space-x-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "error_outline", -1)
const _hoisted_4 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArticleHandle = _resolveComponent("ArticleHandle")!
  const _component_GoogleScopeChecker = _resolveComponent("GoogleScopeChecker")!
  const _component_HelpCenter = _resolveComponent("HelpCenter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(["banner banner-danger mb-8", { shake: _ctx.googleIntegrationStore.studentScopesBannerShaking }]),
          role: "alert",
          onAnimationend: _cache[2] || (_cache[2] = ($event: any) => (_ctx.googleIntegrationStore.studentScopesBannerShaking = false))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.$t("misc.warning")), 1)
            ]),
            _createVNode(_component_GoogleScopeChecker, {
              class: "flex flex-col items-start space-y-4",
              onScopesOk: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onScopesOk())),
              onScopesCheckFailed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onScopesCheckFailed())),
              role: 'student'
            }, {
              noScopes: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("integrations.classroom.student_no_scopes_warning")), 1),
                _createElementVNode("p", null, [
                  _createVNode(_component_ArticleHandle, { articleId: 'why_evo_asks_for_google_scopes' }),
                  _createTextVNode(".")
                ])
              ]),
              outstandingScopes: _withCtx(() => [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("integrations.classroom.student_no_scopes_warning")), 1),
                _createElementVNode("p", null, [
                  _createVNode(_component_ArticleHandle, { articleId: 'why_evo_asks_for_google_scopes' }),
                  _createTextVNode(".")
                ])
              ]),
              _: 1
            })
          ])
        ], 34), [
          [_vShow, _ctx.showMissingScopesBanner]
        ])
      ]),
      _: 1
    }),
    (_ctx.metaStore.helpCenterOpen)
      ? (_openBlock(), _createBlock(_component_HelpCenter, {
          key: 0,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.metaStore.setHelpCenterVisibility(false))),
          allowGoBack: false
        }))
      : _createCommentVNode("", true)
  ]))
}